// Ascend pane — prestige reset display + confirm button. Mutation logic
// (resetting state, granting crowns, carrying forward unlocks) stays in
// main.js; this component just shows the current preview and triggers
// the callback.
import { render } from 'preact';
import { state } from '../systems/state.js';
import { useStore } from './use-store.js';
import { CROWN_BONUS_PER, crownsForLifetime } from '../systems/rate.js';

let onAscend = null;
export function initAscend({ onAscendCb }) { onAscend = onAscendCb; }

function AscendDetail() {
  useStore();
  const have = state.crowns || 0;
  const earnable = crownsForLifetime(state.lifetime);
  const gain = Math.max(0, earnable - have);
  return (
    <>
      you have <b>{have}</b> 👑 (+{Math.round(have * CROWN_BONUS_PER * 100)}% rate).<br />
      ascending now grants <b>+{gain}</b> 👑 (total +{Math.round((have + gain) * CROWN_BONUS_PER * 100)}%).<br />
      <span style={{ opacity: 0.65 }}>resets pumpernickels, bakers, eggs, and effects. keeps achievements and crowns.</span>
    </>
  );
}

function AscendConfirm() {
  useStore();
  const earnable = crownsForLifetime(state.lifetime);
  const gain = Math.max(0, earnable - (state.crowns || 0));
  return (
    <button
      id="ascend-confirm"
      className="treat ascend"
      disabled={gain <= 0}
      onClick={() => onAscend && onAscend()}
    >
      ✨ ascend
    </button>
  );
}

export function mountAscend() {
  const detail = document.getElementById('ascend-detail');
  if (detail) render(<AscendDetail />, detail);
  // The confirm button was a static HTML element; we replace it with a
  // preact-controlled mount. main.js no longer attaches a click listener.
  const confirmBtn = document.getElementById('ascend-confirm');
  if (confirmBtn && confirmBtn.parentNode) {
    const mount = document.createElement('span');
    confirmBtn.parentNode.replaceChild(mount, confirmBtn);
    render(<AscendConfirm />, mount);
  }
}

